export function HomePage() {
  return (
    <div className="center-screen">
      <div className="card stack" style={{ maxWidth: 440, textAlign: "center" }}>
        <p
          style={{
            margin: 0,
            textTransform: "uppercase",
            letterSpacing: "0.16em",
            fontSize: "0.75rem",
            fontWeight: 600,
            color: "var(--color-primary)",
          }}
        >
          Bienvenue
        </p>
        <h1 style={{ fontSize: "clamp(2rem, 6vw, 2.6rem)" }}>Hadrien &amp; Harmine</h1>
        <p>
          Utilisez le lien qui vous a été partagé (par exemple par QR code) pour accéder à la
          galerie de photos et vidéos de l'événement.
        </p>
      </div>
    </div>
  );
}
